<template>
  <div>
    <b-button
        v-if="ableToUpdateCase && ableToCreateTask && getIdLink(item.status['@id']) === '1'"
        class="btn btn-sm btn-info btn-circle float-right"
        v-b-tooltip.hover
        :title="$t('buttons.addTask')"
        @click="toggleCreateTaskModal()">
      <i class="fa fa-plus"></i>
    </b-button>
    <time-line type="simple">
      <time-line-item inverted badge-type="danger" badge-icon="nc-icon nc-briefcase-24" v-if="getIdLink(item.status['@id']) === '2'">
        <b-badge slot="header" variant="danger">{{$t('views.excmcase.show.caseClosed')}}</b-badge>
        <p slot="content"></p>
        <small slot="footer">
          {{$t('views.excmcase.show.finished')}} - {{$moment(item.statusModified).format('YYYY-MM-DD HH:mm')}}
        </small>
      </time-line-item>
      <time-line-item inverted :badge-type="getBadgeTaskColor(task)" badge-icon="nc-icon nc-bullet-list-67" v-for="(task, index) in item.tasks" v-bind:key="task.id">
        <div slot="header">
<!--          Jeżeli task posiada dailyPlanItem, oraz nie jest przeniesiony to wyświetlamy informację o tym-->
          <template v-if="task.dailyPlanItems && task.dailyPlanItems.length > 0 && task.dailyPlanItems[task.dailyPlanItems.length - 1].status !== 2 && task.canViewDetails">
            <h5><i class="fa fa-lg fa-exclamation"></i></h5>
            <b-badge slot="header" variant="info">
              {{$t('views.excmtask.show.dailyPlanItem')}}
            </b-badge>
            <p>
              {{$t('views.excmtask.show.plannedAt')}}
              <router-link
                :to="{ name: 'DailyPlanShow', params: { idServiceman: task.dailyPlanItems[task.dailyPlanItems.length - 1].idUserData['@id'], date: $moment(task.dailyPlanItems[task.dailyPlanItems.length - 1].date).format('YYYY-MM-DD') }}">{{ $moment(task.dailyPlanItems[task.dailyPlanItems.length - 1].date).format('YYYY-MM-DD') }}</router-link>, {{$t('views.excmtask.show.plannedBy')}} {{ task.dailyPlanItems[task.dailyPlanItems.length - 1].idUserData.name }} {{ task.dailyPlanItems[task.dailyPlanItems.length - 1].idUserData.surname }}
            </p>
            <b-button variant="info" size="sm" @click="toggleTransferTaskModal(task)"  v-if="ableToTransferTask(task)">
              <span>{{$t('buttons.transferToAnotherUserDataDailyPlanItem')}}</span>
            </b-button>
            <hr>
          </template>
          <router-link v-if="ableToShowTask" :to="{name: 'EXCMTaskShow', params: { id: task['@id'] }}">
          <span class="mt-0 mb-0" style="color: #2b2422">
            {{task.idTaskType.title}}
          </span>
          </router-link>
          <span v-else class="mt-0 mb-0" style="color: #2b2422">
            {{task.idTaskType.title}}
          </span>
          <div v-if="task.lastPoolTask && task.lastPoolTask.operationTransferUserData && task.canViewDetails">
            {{ $t('modals.finishedTaskDocument.idDoneByUserData') }} - {{ task.lastPoolTask.operationTransferUserData.fullName }}
          </div>
          <TaskExistingCustomFields v-if="task.canViewDetails" :item="task"></TaskExistingCustomFields>
        </div>
        <div slot="content" v-if="task.canViewDetails">
          <div v-if="index === 0" class="text-center">
            <hr class="my-1">
            <div v-if="task.deadlineDate">
              <b-badge :variant="getProgress(task) > 100 ? 'danger' : null">
                {{ getProgress(task) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(task) + ' %' }}
              </b-badge>
              <div>
                <small>
                  {{ $moment(task.createdAt).format('YYYY-MM-DD HH:mm') }}
                </small>
                <small>
                  {{' - ' + $moment(task.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                </small>
              </div>
              <Progress
                v-if="getProgress(task) < 100"
                :type="'primary'"
                :value="getProgress(task)">
              </Progress>
            </div>
            <b-badge v-else>
              {{ $t('views.excmcase.list.noDeadlineDate') }}
            </b-badge>
          </div>
          <router-link class="btn btn-primary btn-sm btn-block mt-2 mb-0" v-if="ableToShowTask && task.canViewDetails" :to="{name: 'EXCMTaskShow', params: { id: task['@id'] }}">
            {{ $t('buttons.goToTask') }}
          </router-link>
        </div>
        <small slot="footer">
          {{$t('views.excmcase.show.created')}} - {{$moment(task.createdAt).format('YYYY-MM-DD HH:mm')}}
          <span v-if="task.finished === 1"><br>{{$t('views.excmcase.show.finished')}} - {{$moment(task.finishDate).format('YYYY-MM-DD HH:mm')}}</span>
        </small>
      </time-line-item>
      <time-line-item inverted badge-type="success" badge-icon="nc-icon nc-briefcase-24">
        <span slot="header" class="mt-0 mb-0" style="color: #2b2422">
          {{$t('views.excmcase.show.caseCreated')}}
        </span>
        <p slot="content"></p>
        <small slot="footer">
          {{$t('views.excmcase.show.created')}} - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
        </small>
      </time-line-item>
    </time-line>
    <TransferTaskModal @success="retrieve" :task="selectedTask"></TransferTaskModal>
  </div>
</template>

<script>
import TimeLine from '../../../../UIComponents/TimeLine/TimeLine'
import TimeLineItem from '../../../../UIComponents/TimeLine/TimeLineItem'
import getId from '../../../../../utils/getIdFromLink'
import { mapMutations } from 'vuex'
import Progress from '@/components/UIComponents/Progress'
import TaskExistingCustomFields from '@/components/Dashboard/Views/excmtask/components/TaskExistingCustomFields'
import TransferTaskModal from '@/components/Dashboard/Views/excmtask/modals/TransferTaskModal'
import { checkPermission } from '@/utils/checkRoles'

export default {
  name: 'CaseTimeline',
  components: {
    TransferTaskModal,
    TaskExistingCustomFields,
    Progress,
    TimeLine,
    TimeLineItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    ableToShowTask: {
      required: true
    },
    ableToUpdateCase: {
      required: true
    }
  },
  data () {
    return {
      selectedTask: {}
    }
  },
  computed: {
    ableToCreateTask () {
      return checkPermission('tasks', 'EXCMTaskCreate')
    }
  },
  methods: {
    ableToTransferTask (task) {
      return !!(task.finished !== 1 && [1, 2, 3].includes(task.lastPoolTask.operation))
    },
    getProgress (item) {
      if (!item.deadlineDate) {
        return 100
      } else {
        let created = this.$moment(item.createdAt)
        let deadline = this.$moment(item.deadlineDate)
        return this.calculateProgress(created, deadline)
      }
    },
    calculateProgress (created, deadline) {
      let denominator, nominator
      denominator = deadline.diff(created)
      nominator = this.$moment().diff(created)
      return Math.round((nominator / denominator) * 100)
    },
    ...mapMutations({
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal',
      toggleTransferModal: 'excmtask/transferModal/toggleModal'
    }),
    getIdLink (link) {
      return getId(link)
    },
    getBadgeTaskColor (task) {
      if (task.finished === 1) {
        return 'success'
      } else {
        return 'danger'
      }
    },
    toggleTransferTaskModal (task) {
      this.selectedTask = task
      this.toggleTransferModal()
    },
    retrieve () {
      this.$emit('reload')
    }
  }
}
</script>

<style scoped>

</style>
